import type { Blueprint } from '../../base/blueprints/Blueprint';

export interface HasFilter extends Blueprint
{
    showFilter: boolean;
}

export const instanceOfHasFilter = (object: any): object is HasFilter =>
{
    return object && 'showFilter' in object;
};
